import script from "./AddEditIssuerView.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditIssuerView.vue?vue&type=script&setup=true&lang=js"

import "./AddEditIssuerView.vue?vue&type=style&index=0&id=58fb4520&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58fb4520"]])

export default __exports__